import { Action, Reducer, ActionCreatorsMapObject } from 'redux';

import { ApplicationState, AppThunkAction } from '@app/store';

import { AppointmentProcedureMenuDoctor } from '@app/objects/Appointment';
import { Doctor } from '@app/objects/Doctor';

export interface DoctorState {
	id: number;
	color: string;
	firstNameEn: string;
	lastNameEn: string;
	avatar?: string;
	original?: string;
}

export interface MenuTabState {
	id: number;
	doctorIds: Array<number>;
}

export interface State {
	doctors: Array<DoctorState>;
	menuTabState: Array<MenuTabState>;
}

export enum TypeKeys {
	SETDOCTORS = 'SETDOCTORS',
	REMOVE = 'REMOVE',
	ADDDOCTOR = 'ADDDOCTOR',
	CHOOSEDOCTOR = 'CHOOSEDOCTOR',
}

interface SetDoctors {
	type: TypeKeys.SETDOCTORS;
	menuDoctors: Array<AppointmentProcedureMenuDoctor>;
}

interface Remove {
	type: TypeKeys.REMOVE;
	doctorId: number;
	id?: number;
}

interface AddDoctor {
	type: TypeKeys.ADDDOCTOR;
	doctor: DoctorState;
}

interface ChooseDoctor {
	type: TypeKeys.CHOOSEDOCTOR;
	doctorId: number;
	id: number;
}

const InitialState = {
	doctors: [],
	menuTabState: [],
};

export type Actions = SetDoctors | ChooseDoctor | Remove | AddDoctor;

export interface ActionCreators extends ActionCreatorsMapObject {
	setDoctors: (menuDoctors: Array<AppointmentProcedureMenuDoctor>) => AppThunkAction<Actions>;
	addDoctor: (doctor: DoctorState) => AppThunkAction<Actions>;
	removeDoctor: (doctorId: number, id?: number) => AppThunkAction<Actions>;
	chooseDoctor: (doctorId: number, id: number) => AppThunkAction<Actions>;
}

export const actionCreators = (dispatch, getState?: () => ApplicationState) => ({
	setDoctors: (menuDoctors) => {
		dispatch({ type: TypeKeys.SETDOCTORS, menuDoctors });
	},
	addDoctor: (doctor) => {
		dispatch({ type: TypeKeys.ADDDOCTOR, doctor });
	},
	removeDoctor: (doctorId, id) => {
		dispatch({ type: TypeKeys.REMOVE, doctorId, id });
	},
	chooseDoctor: (doctorId, id) => {
		dispatch({ type: TypeKeys.CHOOSEDOCTOR, doctorId, id });
	},
});

export const reducer: Reducer<State> = (
	state: State = InitialState,
	incomingAction: Action = { type: '' },
) => {
	const action = incomingAction as Actions;

	switch (action.type) {
		case TypeKeys.SETDOCTORS:
			/* eslint-disable */
			const menuTabStateTemp: Array<MenuTabState> = [];
			const doctorsTemp: Array<Doctor> = [];

			action.menuDoctors?.map((md) => {
				if (md.doctorMenuId && !menuTabStateTemp.some((el) => el.id === md.doctorMenuId)) {
					menuTabStateTemp.push({
						id: md.doctorMenuId,
						doctorIds: action.menuDoctors.filter((m) => m.doctorMenuId === md.doctorMenuId).map((m) => m.doctorId),
					});
				}
				if (md.doctor && !doctorsTemp.some((el) => el.id === md.doctorId)) {
					doctorsTemp.push(md.doctor);
				}
			});
			/* eslint-enable */

			return {
				...state,
				menuTabState: menuTabStateTemp,
				doctors: doctorsTemp,
			};
		case TypeKeys.ADDDOCTOR:
			if (state.doctors.find(({ id }) => id === action.doctor.id)) {
				return state;
			}
			return {
				...state,
				doctors: state.doctors.concat(action.doctor),
			};
		case TypeKeys.REMOVE:
			return {
				doctors: action.id === undefined
					? state.doctors.filter(({ id }) => id !== action.doctorId) : state.doctors,
				menuTabState: state.menuTabState
					.map((q) =>
						(q.id === action.id || action.id === undefined ? {
							...q,
							doctorIds: q.doctorIds.filter((id) => id !== action.doctorId),
						} : q)),
			};
		case TypeKeys.CHOOSEDOCTOR:
			if (state.menuTabState.find(({ id }) => id === action.id) !== undefined) {
				const newMenuTabState = state.menuTabState
					.map((q) => (q.id === action.id
						? {
							...q,
							doctorIds: q.doctorIds
								.filter((id) => id !== action.doctorId)
								.concat([action.doctorId]),
						} : q));
				return { ...state, menuTabState: newMenuTabState };
			}

			return { ...state, menuTabState: state.menuTabState.concat({ id: action.id, doctorIds: [action.doctorId] }) };
		default:
			return state;
	}
};
